<template>
  <footer class="footer">
    <div class="footer__container">
      <div class="footer__body">
        <router-link :to="localizedRoute('home')" class="footer__logo">
          <img src="/logo/logo.webp" alt="Logo" />
        </router-link>

        <nav class="footer__nav">
          <ul class="footer__nav-list">
            <li v-for="menuItem in menuItemsList" :key="menuItem.name">
              <router-link 
                :to="{ name: menuItem.name, params: { locale: $i18n.locale } }"
              >
                {{ $t(`menu.${menuItem.titleLabel}`) }}
              </router-link>
            </li>
          </ul>
        </nav>

        <div class="footer__contact">
          <i class="fa fa-phone footer__icon"></i>
          <a href="tel:+373 600 11 444">+373 600 11 444</a>
        </div>
      </div>
        <div class="footer__date center">
          <p>&copy; {{ currentYear }} All rights are protected.</p>
        </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
  data() {
    return {
      menuItemsList: [
        { name: "home", titleLabel: "home" },
        { name: "about", titleLabel: "about" },
        { name: "services", titleLabel: "services" },
        { name: "vacancies", titleLabel: "vacancies" },
        { name: "contacts", titleLabel: "contacts" }
      ],
      currentYear: new Date().getFullYear(),
    };
  },
  methods: {
    localizedRoute(name) {
      const locale = this.$i18n.locale;
      const localizedPath = this.$i18n.t(`url.${name}`);
      return localizedPath ? (name === "home" ? `/${locale}` : `/${locale}/${localizedPath}`) : `/${locale}`;
    },
  }
};
</script>


